// [claude-code 2026-04-05] Fix sidebar icons to match main Consilium toolbar (Scroll, Plus, Clock)
// [claude-code 2026-04-03] Extracted from MainLayout.tsx — sliding chat panel
import React, { useRef, useState } from "react";
import { X, Scroll, Plus, Clock, PictureInPicture2 } from "lucide-react";
import { ChatSidebar } from "../chat/ChatSidebar";
import { SessionsModal } from "../chat/SessionsModal";
interface ChatPanelProps {
  showChat: boolean;
  onClose: () => void;
  navigateTab: (tab: string) => void;
  pipAvailable?: boolean;
  onPopOut?: () => void;
}

export function ChatPanel({
  showChat,
  onClose,
  pipAvailable = false,
  onPopOut,
}: ChatPanelProps) {
  const [showSessionsDropdown, setShowSessionsDropdown] = useState(false);
  const sessionsButtonRef = useRef<HTMLButtonElement | null>(null);

  return (
    <div
      className={`fintheon-side-surface fintheon-shell-side-panel fintheon-drawer-right relative z-20 flex h-full shrink-0 flex-col overflow-hidden border-l border-[var(--fintheon-accent)]/20 bg-[var(--fintheon-surface)] transition-[width,opacity,transform] duration-300 ease-in-out ${
        showChat
          ? "w-[min(420px,42vw)] opacity-100"
          : "w-0 translate-x-2 opacity-0 pointer-events-none invisible"
      }`}
      data-chat-side-panel="true"
      data-agent-chat-surface={showChat ? "sidebar chat" : undefined}
      style={{
        transform: showChat ? "translateX(0)" : undefined,
      }}
    >
      <div className="flex items-center justify-between px-3 py-2 flex-shrink-0">
        {/* Left icons — match main Consilium chat toolbar: Report, New, History */}
        <div className="flex items-center gap-0.5">
          <button
            onClick={() =>
              window.dispatchEvent(new Event("fintheon:chat-run-report"))
            }
            className="p-1.5 rounded-md text-zinc-600 hover:text-[var(--fintheon-accent)] hover:bg-[var(--fintheon-accent)]/8 transition-colors"
            title="Run Report"
          >
            <Scroll className="w-3.5 h-3.5" />
          </button>
          <button
            onClick={() => window.dispatchEvent(new Event("fintheon:chat-new"))}
            className="p-1.5 rounded-md text-zinc-600 hover:text-[var(--fintheon-accent)] hover:bg-[var(--fintheon-accent)]/8 transition-colors"
            title="New Chat"
          >
            <Plus className="w-3.5 h-3.5" />
          </button>
          <button
            ref={sessionsButtonRef}
            onClick={() => setShowSessionsDropdown((prev) => !prev)}
            className="p-1.5 rounded-md text-zinc-600 hover:text-[var(--fintheon-accent)] hover:bg-[var(--fintheon-accent)]/8 transition-colors"
            title="History"
          >
            <Clock className="w-3.5 h-3.5" />
          </button>
          <SessionsModal
            isOpen={showSessionsDropdown}
            portal
            anchorRef={sessionsButtonRef}
            historySurface="chat"
            onClose={() => setShowSessionsDropdown(false)}
            onSelectSession={(id) => {
              window.dispatchEvent(
                new CustomEvent("fintheon:chat-load-session", {
                  detail: { id },
                }),
              );
              setShowSessionsDropdown(false);
            }}
            onNewSession={() => {
              window.dispatchEvent(new Event("fintheon:chat-new"));
              setShowSessionsDropdown(false);
            }}
          />
        </div>
        {/* Close */}
        <div className="flex items-center gap-0.5">
          {pipAvailable ? (
            <button
              onClick={onPopOut}
              className="p-1.5 rounded-md text-zinc-600 hover:text-[var(--fintheon-accent)] hover:bg-[var(--fintheon-accent)]/8 transition-colors"
              title="Pop out CAO chat"
              aria-label="Pop out CAO chat"
            >
              <PictureInPicture2 className="w-3.5 h-3.5" />
            </button>
          ) : null}
          <button
            onClick={onClose}
            className="p-1.5 rounded-md text-zinc-600 hover:text-[var(--fintheon-accent)] hover:bg-[var(--fintheon-accent)]/8 transition-colors"
            title="Close"
          >
            <X className="w-3.5 h-3.5" />
          </button>
        </div>
      </div>
      <div className="flex-1 min-h-0 overflow-hidden">
        <ChatSidebar />
      </div>
    </div>
  );
}
